<template>
  <div
    style="background-color: #fff;position: fixed;z-index: 111;;width: 100vw;height: 100vh;overflow-y: auto;top: 0;left: 0;">
    <div>
      <van-nav-bar :title="$t('orderpop.order_confirm')" fixed left-arrow @click-left="onClickLeft" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div>
    <div class="pop_container">
      <div class="title">{{ $t('orderpop.service_details') }}</div>
      <div class="girlInfo">
        <div class="avatar"><img
            :src="infodata.img_url[0]" alt=""></div>
        <div class="info">
          <!-- 昵称/城市/类型来自 DB 且为中文：按需求换成编号展示、不再展示地区 / nickname+city+type came from the DB in Chinese; replaced by the ID and dropped per client request -->
          <!-- <p class="customizedColor717">{{infodata.xuanfei_name}}<span class="verified">{{ $t('orderpop.verified') }}</span></p> -->
          <p class="customizedColor717"><span class="verified">{{ $t('orderpop.verified') }}</span>ID:#{{ ('' + (infodata.id || '')).slice(0,3) }}**</p>
          <!-- <p>{{ $t('orderpop.age') }}: {{infodata.age}} &nbsp;{{ $t('orderpop.height') }}: {{infodata.hight}}CM &nbsp;<span>{{ $t('orderpop.bust') }}: {{infodata.bust}}</span> &nbsp;{{infodata.class_name}} &nbsp;{{infodata.address}}</p> -->
          <p>{{ $t('orderpop.age') }}: {{infodata.age}} &nbsp;{{ $t('orderpop.height') }}: {{infodata.hight}}CM &nbsp;<span>{{ $t('orderpop.bust') }}: {{infodata.bust}}</span></p>
        </div>
      </div>
      <hr>
      <div class="title">{{ $t('orderpop.tips') }}</div>
      <p>{{ $t('orderpop.support_tip') }}</p>
      <hr>
      <div class="title">{{ $t('orderpop.visit_confirm') }}</div>
      <p>{{ $t('orderpop.contact_reception') }}</p>
      <!-- 促销条：改用英文版新图，原中文图 /img/infobg1.png 保留未删 -->
      <img src="/img/infobg1-en.png" style="width:100%">
      <!-- <img src="/img/infobg1.png" style="width:100%"> -->
    </div>
    <div style="padding-bottom: 20vw; background-color: transparent;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props:['infodata'],
  methods: {
    onClickLeft() {
      this.$emit('close')
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: rgb(172, 98, 204);
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: rgb(172, 98, 204);
  border-bottom-width: 0;
}

.pop_container {
  padding: 120px 34px 34px 34px;
}
.pop_container p {
  color: #000;
  font-size: 24px;
  padding-bottom: 30px;
}
.pop_container hr {
  border-color: #333333;
}
.pop_container .girlInfo {
  display: flex;
  position: relative;
  padding-bottom: 34px;
}
.pop_container .girlInfo .avatar {
  width: 102px;
  height: 102px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
}
.pop_container .girlInfo .avatar img:first-child {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  border: 2px solid #ff8395;
}
.pop_container .girlInfo .info {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.pop_container .girlInfo .info p:nth-child(1) {
  font-size: 24px;
  color: #000;
  font-weight: 500;
  /* 徽章与 ID 改为同一行流式排列：原胶囊 :before 是绝对定位、宽度写死 3.125rem，
     英文 "Verified" 比胶囊宽，才会压到后面的 ID 文字上 */
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-bottom: 0;
  /* 胶囊底色交给 .verified 自己画，:before 只负责左边的小图标 */
  .verified:before {
    content: '';
    display: block;
    /* 只画左侧小图标，不再画整颗胶囊 */
    width: 0.5625rem;
    height: 0.59375rem;
    border-top-left-radius: 0.3125rem;
    border-bottom-right-radius: 0.3125rem;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), -webkit-linear-gradient(#ff556e, #ff8395);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), linear-gradient(#ff556e, #ff8395);
    background-repeat: no-repeat, no-repeat;
    background-size: 0.5625rem 0.59375rem, cover;
    background-position: 0 0, 0 0;
    position: absolute;
    left: 0.5rem;
    top: 0.25rem;
}
/* Verified 徽章：宽度随文案自适应的紫色胶囊（左侧小图标由上面的 :before 绘制），不再压住 ID */
.verified {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    position: relative;
    height: 1.0625rem;
    margin-right: 0.625rem;
    padding: 0 0.5rem 0 1.4rem;
    border-radius: 0.3125rem 0 0.3125rem 0;
    background-image: -webkit-linear-gradient(#ac62cc, #ac62cc);
    background-image: linear-gradient(#ac62cc, #ac62cc);
    font-weight: bold;
    font-family: PingFang SC;
    color: #000;
    font-size: 20px;
    line-height: 1;
    white-space: nowrap;
}
}
.pop_container .girlInfo .info p.customizedColor717 .verified:before {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), -webkit-linear-gradient(#ac62cc, #ac62cc);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), linear-gradient(#ac62cc, #ac62cc);
}
.pop_container .girlInfo .info p:nth-child(2) {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000;
    padding-left: 24px;
    margin-top: 4px;
    padding-bottom: 0;
}

.pop_container .title {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #262626;
  padding: 34px 40px;
  background: url(/img/xin.png) no-repeat;
  background-size: 28px 26px;
  background-position: 0 center;
}

</style>
